import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: () => import('../components/common/Home.vue'),
            children: [
                {
                    path: '/dashboard',
                    component: () => import('../components/page/Dashboard.vue'),
                    meta: { title: '系统首页' }
                },
                {
                    path: '/summary',
                    component: () => import('../components/page/Summary.vue'),
                    meta: { title: '本月汇总',permission: true}
                },
                {
                    path: '/order',
                    component: () => import('../components/page/Order.vue'),
                    meta: { title: '订单管理',permission: true }
                },
                {
                    path: '/add',
                    component: () => import('../components/page/Add.vue'),
                    meta: { title: '新增信息',permission: true }
                },
                {
                    path: '/line',
                    component: () => import('../components/page/Line.vue'),
                    meta: { title: '付费走势图',permission: true }
                },
                {
                    path: '/details',
                    component: () => import('../components/page/Details.vue'),
                    meta: { title: '账目明细', permission: true }
                },
                {
                    path: '/customized',
                    component: () => import('../components/page/Customized.vue'),
                    meta: { title: '配置定制套餐' }
                },
                {
                    path: '/stripe',
                    component: () => import('../components/page/Stripe.vue'),
                    meta: { title: 'Stripe信用卡支付' }
                },
                {
                    path: '/changeless',
                    component: () => import('../components/page/Changeless.vue'),
                    meta: { title: '固定套餐支付' }
                },
                {
                    path: '/user',
                    component: () => import('../components/page/User.vue'),
                    meta: { title: '用户账号管理' }
                },
                {
                    path: '/extension',
                    component: () => import('../components/page/Extension.vue'),
                    meta: { title: '推广列表' }
                },
                {
                    path: '/getEmail',
                    component: () => import('../components/page/GetEmail.vue'),
                    meta: { title: '获取邮箱' }
                },
                {
                    path: '/share',
                    component: () => import('../components/page/Share.vue'),
                    meta: { title: '创建分享链接' }
                },
                {
                    path: '/update',
                    component: () => import('../components/page/Update.vue'),
                    meta: { title: '富文本上传' }
                },
                {
                    path: '/404',
                    component: () => import('../components/page/404.vue'),
                    meta: { title: '404' }
                },
            ]
        },
        {
            path: '/login',
            component: () => import('../components/page/Login.vue'),
            meta: { title: '登录' }
        },

    ]
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}